import React from "react";
import {
  AccessTime,
  InfoOutlined,
  Inventory2Outlined,
  MergeType,
} from "@mui/icons-material";
import { Box, Grid } from "@mui/material";

import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import Status from "components/Shared/Status";

import { useConsolidationDetailContext } from "contexts/ConsolidationDetailContext";
import { localizeDateTimeShort } from "utils/dateFormats";

const ConsolidationBasicDetail = () => {
  const { consolidationDetail, loadingConsolidation } =
    useConsolidationDetailContext();


  return !loadingConsolidation ? (
    <Box padding={3}>
      <Grid container spacing={4}>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <Inventory2Outlined color="primary" />}
            title="Consolidation ID"
            subtitle={consolidationDetail?.consolidationId || "N/A"}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <MergeType color="primary" />}
            title="Type"
            subtitle={consolidationDetail?.type || "N/A"}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <MergeType color="primary" />}
            title="Load Type"
            subtitle={consolidationDetail?.loadType || "N/A"}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Name"
            subtitle={consolidationDetail?.name || "N/A"}
          />
        </Grid>
       <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Mode"
            subtitle={
              consolidationDetail?.mode === "Source"
                ? consolidationDetail?.route?.routeName
                  ? `Source: ${consolidationDetail.route.routeName} (Route)`
                  : consolidationDetail?.branch?.name
                  ? `Source: ${consolidationDetail.branch.name} (Branch)`
                  : "N/A"
                : consolidationDetail?.mode === "In Transit"
                ? consolidationDetail?.warehouse?.name
                  ? `In-Transit: ${consolidationDetail.warehouse.name} (Warehouse)`
                  : "N/A"
                : "N/A"
            }
            // subtitleSecondary={consolidationDetail?.mode || "N/A"}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Created By"
            subtitle={consolidationDetail?.createdBy?.name	 || "N/A"}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Deconsolidation Status"
            subtitle={consolidationDetail?.deconsolidationStatus	 || "N/A"}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <AccessTime color="primary" />}
            title="Deconsolidation Time"
            subtitle={localizeDateTimeShort(consolidationDetail?.consolidationTime)}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Is Active ?"
          >
            <Status isActive={consolidationDetail?.isActive} />
          </InformationTile>
        </Grid>
        <Grid item xs={12}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Description"
            subtitle={consolidationDetail?.description || "N/A"}
          />
        </Grid>
      </Grid>
    </Box>
  ) : (
    <InfoGridSkeleton />
  );
};

export default ConsolidationBasicDetail;